<div *ngIf="!faturaEncontrada" class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
            <h2 class="mb-1">A fatura não foi encontrada 🕵🏻‍♀️</h2>
            <p class="mb-2">Verifique se o link está correto ou entre em contato com o suporte.</p>
        </div>
    </div>
</div>

<div *ngIf="faturaEncontrada" class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section class="invoice-preview-wrapper">
            <div class="row invoice-preview">
                <!-- Invoice -->
                <div class="col-xl-12 col-md-12 col-12 printRef">
                    <div class="card invoice-preview-card">
                        <div class="card-body invoice-padding pb-0">
                            <!-- Header Starts -->
                            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                                <div>
                                    <div class="logo-wrapper">
                                        <img style="border-radius: 15%;" src="assets/images/ico/favicon.ico" alt="">
                                        <h3 class="text-primary invoice-logo mt-1">Grupo 2E</h3>
                                    </div>
                                    <p class="card-text mb-25">Av. Pastor Martin Luther King Jr, 126 - Office 3000 sl
                                        1101 </p>
                                    <p class="card-text mb-25">Rio de Janeiro, RJ 20760-005, BR</p>
                                    <p class="card-text mb-0">(21) 2042-2324</p>
                                </div>
                                <div class="mt-md-0 mt-2">
                                    <!-- <h4 class="invoice-title">
                                        Número do pedido
                                        <span class="invoice-number">#{{ apiData.id }}</span>
                                    </h4>
                                    <div class="invoice-date-wrapper">
                                        <p class="invoice-date-title">Date Issued:</p>
                                        <p class="invoice-date">{{ apiData.issuedDate }}</p>
                                    </div>
                                    <div class="invoice-date-wrapper">
                                        <p class="invoice-date-title">Due Date:</p>
                                        <p class="invoice-date">{{ apiData.dueDate }}</p>
                                    </div> -->
                                </div>
                            </div>
                            <!-- Header Ends -->
                        </div>

                        <hr class="invoice-spacing" />

                        <!-- Address And Contact Starts -->
                        <div class="card-body invoice-padding pt-0 ml-1">
                            <div class="row invoice-spacing">
                                <div class="col-xl-8 p-0">
                                    <h3 class="text-primary invoice-logo">Cliente</h3>
                                    <p class="card-text mb-25">Razão Social: {{ apiData.razao_social }}</p>
                                    <p class="card-text mb-25">Nome Fantasia: {{ apiData.nome_cliente }}</p>
                                    <p class="card-text mb-25">CPF/CNPJ: {{ apiData.cpfCnpj }}</p>
                                    <p class="card-text mb-25">Endereço: {{ apiData.rua + ', ' + apiData.bairro + ', ' +
                                        apiData.estado
                                        }}</p>
                                    <p class="card-text mb-25">CEP: {{ apiData.cep }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Address And Contact Ends -->

                        <!-- Invoice Description Starts -->
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="py-1">Itens do Pedido</th>
                                        <th class="py-1">Valor</th>
                                        <th class="py-1">Quantidade</th>
                                        <th class="py-1">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="border-bottom">
                                        <td class="py-1">
                                            <p class="card-text font-weight-bold mb-25">Ui Kit Design</p>
                                            <p class="card-text text-nowrap">
                                                Designed a UI kit for native app using Sketch, Figma & Adobe XD
                                            </p>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$60.00</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">20</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$1200.00</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Invoice Note Starts -->
                        <div class="card-body invoice-padding pt-2">
                            <div class="row">
                                <div class="col-12">
                                    <span class="font-weight-bold">Note: </span>
                                    <span>It was a pleasure working with you and your team. We hope you will keep us in
                                        mind for future
                                        freelance projects. Thank You!</span>
                                </div>
                            </div>
                        </div>
                        <!-- Invoice Note Ends -->
                    </div>
                </div>
                <!--/ Invoice -->
            </div>
        </section>
    </div>


</div>